import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getComments: {
    method: 'GET',
    url: `${configs.baseUrl}/api/public/conversation-presenter-share/list/{presentationId}-{uniqueAccessCode}?page=1&limit=200`,
  },
  sendComment: {
    method: 'POST',
    url: `${configs.baseUrl}/api/public/conversation-presenter-share/add-message`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getComments = async (presentationId, uniqueAccessCode) => {
  const res = await resource.getComments({ presentationId, uniqueAccessCode })
  return res.body
}

const sendComment = async (params) => {
  const res = await resource.sendComment(params)
  return res.body
}

export default {
  initResource,
  getComments,
  sendComment,
}
